export const PROCESSES = Object.freeze({
    CTP_TASK_ID: 71, // CTP - - done
    PRINT_TASK_ID: 43, // DRUK - done
    DIE_CUTTING_TASK_ID: 36, // SZTANCOWANIE - done
    CLEANING_AFTER_DIE_CUTTING_TASK_ID: 100, // OCZYSZCZANIE PO SZTANCOWANIU - done
    FOLDER_GLUER_TASK_ID: 131, // SKŁADARKO-SKLEJARKA - done
    CUTTING_PAPER_TASK_ID: 68, // DOCINANIE PAPIERU PRZED DRUKIEM - done
    SLICING_AFTER_PRINTING_TASK_ID: 37, // KROJENIE PO DRUKU - done
    SLICING_AFTER_FINISHING_TASK_ID: 66, // KROJENIE PO USZLACHETNIANIU - done
    SLICING_AFTER_DIE_CUTTING_TASK_ID: 89, // KROJENIE PO SZTANCOWANIU - done
    LAMINATION_TASK_ID: 51, // FOLIOWANIE - done
    PACKING_TASK_ID: 44, // PAKOWANIE - done
    SENDING_TASK_ID: 45, // WYSYŁKA - done
    FINISHING_TASK_ID: 34, // USZLACHETNIANIE UV - done
    COOPERATION_TASK_ID: 52, // KOOPERACJA - done
    FOLDING_TASK_ID: 46, // FALCOWANIE - done
    SEWN_BIND_TASK_ID: 41, // OPRAWA SZYTA - done
    GLUE_BIND_TASK_ID: 40 // OPRAWA KLEJONA - done
})

export const SHARED_PROCESSES: readonly number[] = [
    PROCESSES.SENDING_TASK_ID,
    PROCESSES.PACKING_TASK_ID,
    PROCESSES.FOLDER_GLUER_TASK_ID
] as const
